import React, { useContext, useMemo } from "react";
import { DataTable, QueryResult, Table } from "@sscs/ui";
import { getQueryStatus } from "@sscs/utils";
import { expandedRowsUpdated, focusedRowUpdated, selectExpandedRow, selectFocusedRow, } from "../../../../store/issuesDiffSlice";
import { selectScrollTo } from "../../../../store/sdlcReportSlice";
import { ExpandedRowDetails } from "../../../../ui";
import { compareIssueOverrides } from "../../../../utils";
import { IssueOverrides, PolicyRecommendation } from "../../../common";
import { ReportContext } from "../../../context";
import { useReportDispatch, useReportSelector, useScrollIntoView, } from "../../../hooks";
import { useGetThreatHuntingDetailsQuery } from "../../../services/diff.api";
import { generateOverrideId } from "../../../utils";
import FilesList from "./FilesList";
const IssueDetails = ({ issue, }) => {
    const { diffId } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const scrollTo = useReportSelector(selectScrollTo);
    const focusedRow = useReportSelector((state) => selectFocusedRow(state, "threatHunting"));
    const isExpanded = useReportSelector((state) => selectExpandedRow(state, issue.id, "threatHunting"));
    const { data = { files: [], match_count: 0 }, isLoading, isFetching, isError, error, } = useGetThreatHuntingDetailsQuery({
        diffId: diffId,
        issueId: issue.id,
    }, { skip: !isExpanded });
    // Split into lists by override on frontend because this is a very rare edge case
    const fileListsByOverride = useMemo(() => {
        const result = {};
        issue.overrides.forEach((override) => {
            const overrideId = generateOverrideId(override);
            result[overrideId] = {
                override: override,
                files: [],
                id: `${issue.id}-${overrideId}`,
            };
        });
        data.files.forEach((file) => {
            var _a;
            const overrideId = generateOverrideId({
                component_count: 1,
                enabled: file.enabled,
                status: file.status,
            });
            (_a = result[overrideId]) === null || _a === void 0 ? void 0 : _a.files.push(file);
        });
        return Object.values(result).sort((first, second) => {
            return compareIssueOverrides(first.override, second.override);
        });
    }, [data.files, issue]);
    useScrollIntoView(scrollTo, issue.id);
    return (React.createElement(DataTable.ExpandedRow, { id: issue.id, focused: focusedRow === issue.id, expanded: isExpanded, onChange: (isExpanded) => dispatch(expandedRowsUpdated({
            id: issue.id,
            expand: isExpanded,
            dataType: "threatHunting",
        })), onClick: () => dispatch(focusedRowUpdated({ id: issue.id, dataType: "threatHunting" })) },
        React.createElement(DataTable.ExpandedRow.Summary, null,
            React.createElement(Table.Cell, null, issue.id),
            React.createElement(Table.Cell, null, issue.description),
            React.createElement(IssueOverrides, { issue: issue })),
        React.createElement(DataTable.ExpandedRow.Details, null,
            React.createElement(ExpandedRowDetails, null,
                React.createElement(ExpandedRowDetails.Aside, null,
                    React.createElement(PolicyRecommendation, { recommendation: issue.recommendation, effort: issue.effort, violationCount: issue.count.violations })),
                React.createElement(ExpandedRowDetails.Main, null,
                    React.createElement(QueryResult, { status: getQueryStatus({
                            data,
                            isLoading,
                            isFetching,
                            isError,
                            error,
                        }) }, fileListsByOverride.map((fileList) => (React.createElement(FilesList, { key: fileList.id, id: fileList.id, files: fileList.files, override: fileList.override })))))))));
};
export default IssueDetails;
//# sourceMappingURL=IssueDetails.js.map